import React from "react";
import * as toastConst from "../const/toasts.const";
import ToasterLink from "../components/ToasterLink/index";
import { toast } from "react-toastify";

export const toastifyNewCommand = (data) => ({
  type: toastConst.TOASTIFY_NEW_COMMAND,
  payload: toast(<ToasterLink id_order={data.id_order} />),
});
